import { render, staticRenderFns } from "./ProfileInstagram.vue?vue&type=template&id=af8ef748"
import script from "./ProfileInstagram.vue?vue&type=script&lang=js"
export * from "./ProfileInstagram.vue?vue&type=script&lang=js"
import style0 from "./ProfileInstagram.vue?vue&type=style&index=0&id=af8ef748&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports